import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  InputBase,
  Typography
} from '@material-ui/core';
import BoxCenter from '../components/BoxCenter';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    pointerEvents: 'all',
    zIndex: 2
  },
  bg: {
    alignItems: 'center',
    backgroundImage: 'url(images/register/bg.png)',
    display: 'flex',
    flexDirection: 'column',
    height: 450,
    justifyContent: 'center',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(4),
    width: 450
  },
  gridItem: {
    margin: theme.spacing(1)
  },
  root: {
    transform: ({ scale }) => `scale(${window.devicePixelRatio * scale})`,
    pointerEvents: 'all'
  },
  submitButton: {
    backgroundColor: 'transparent',
    backgroundImage: 'url(images/register/btn_darkblue_L_normal.png)',
    backgroundSize: 'contain',
    border: 'none',
    color: 'white',
    height: 95,
    outline: 'none',
    paddingBottom: 30,
    fontFamily: 'PJ_WangNgan',
    fontSize: '40px',
    width: 167,
    '&:active': {
      paddingBottom: 25,
      backgroundImage: 'url(images/register/btn_darkblue_L_active.png)'
    }
  },
  textField: {
    backgroundImage: 'url(images/register/framing_3.png)',
    height: 50,
    padding: theme.spacing(1),
    width: 350
  },
  titleBar: {
    alignItems: 'center',
    backgroundImage: 'url(images/register/title_gold.png)',
    display: 'flex',
    color: 'white',
    height: 100,
    justifyContent: 'center',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    position: 'absolute',
    top: '-10%',
    width: 290
  }
}));
const formTypes = {
  email: 'อีเมล',
  password: 'รหัสผ่านใหม่',
  rePassword: 'กรอกรหัสอีกครั้ง'
};
const initialState = {
  email: '',
  password: '',
  rePassword: ''
};

const Register = ({ onSubmit, scale, loading }, ref) => {
  const {
    backDrop,
    bg,
    gridItem,
    root,
    submitButton,
    textField,
    titleBar
  } = useStyles({
    scale
  });
  const [form, setForm] = useState(initialState);
  const [errorMessage, setErrorMessage] = useState('');
  useImperativeHandle(ref, () => ({
    setError: err => {
      setErrorMessage(err);
    }
  }));
  const handleTextFieldChange = ({ target }) => {
    setForm({ ...form, [target.name]: target.value });
  };
  const handleSubmit = () => {
    if (!Object.keys(formTypes).some(k => form[k] === '')) {
      if (form.password === form.rePassword) {
        if (form.password.length < 6 || form.password.length > 12) {
          console.log(
            'Your password must contain between 6 and 12 characters. Please try again.'
          );
          setErrorMessage('รหัสผ่านของคุณจะต้องมีอย่างน้อย 6 ตัวอักษร');
        } else {
          onSubmit(form);
        }
      } else {
        console.log('Password and confirm password does not match');
        setErrorMessage('รหัสผ่านทั้งสองไม่ตรงกัน');
      }
    } else {
      console.log('please fill the required fields');
      setErrorMessage('กรุณากรอกข้อมูลให้ครบ');
    }
  };
  return (
    <BoxCenter>
      <Box maxWidth={450} height={500} className={root}>
        <div className={bg}>
          <div className={titleBar}>
            <Typography variant="h3" color="inherit">
              เปลี่ยนรหัสผ่าน
            </Typography>
          </div>
          <Box position="absolute" right={52} bottom={91}>
            <Typography variant="h6" color="error" align="center">
              {errorMessage}
            </Typography>
          </Box>
          <Grid container direction="column" alignContent="center">
            {Object.keys(formTypes).map((key, idx) => (
              <Grid item key={key} className={gridItem}>
                <Typography variant="h4">{formTypes[key]}</Typography>
                <InputBase
                  className={textField}
                  type={!idx ? 'email' : 'password'}
                  name={key}
                  value={form[key]}
                  inputProps={{
                    maxLength: !idx ? 320 : 12
                  }}
                  onChange={handleTextFieldChange}
                  placeholder={!idx ? 'example@mail.com' : 'password'}
                />
              </Grid>
            ))}
          </Grid>
        </div>
        <Box p={1} display="flex" justifyContent="center">
          <button onClick={handleSubmit} className={submitButton}>
            ตกลง
          </button>
        </Box>
      </Box>
      <Backdrop className={backDrop} open={loading}>
        <CircularProgress />
      </Backdrop>
    </BoxCenter>
  );
};
export default forwardRef(Register);
